export const payloadPaymentOptionsTransform = ({ state, ...args }) => {
    const purchaseMethodSelected = args.purchaseMethod || state.paymentOptions.purchaseMethod
    const jwt = args.jwt || state.jwt

    let infoPayload = {}
    if (purchaseMethodSelected === 'finance' || purchaseMethodSelected === 'lease')
        infoPayload = payloadFinanceLease(state, purchaseMethodSelected, args)
    else infoPayload = payloadCash(state, purchaseMethodSelected, args)

    return {
        quoteId: state.quoteId,
        orgId: state.dealerInfos.orgId,
        orgUnitId: state.dealerInfos.orgUnitId,
        location: state.dealerInfos.location,
        lang: state.dealerInfos.lang,
        payload: {
            ...infoPayload,
        },
        token: jwt,
    }
}

const payloadCash = (state, purchaseMethod, args) => {
    const {
        paymentOptions: {
            kmPerYearPlan,
            paymentFrequency,
            saleType,
            taxPlan,
            term,
            odometer,
            transactionToken,
            vehicleCondition,
            cashDown,
            tradeIn,
            lien,
            financeOptions,
        },
    } = state

    return {
        transactionToken,
        saleType,
        taxPlan,
        vehicleCondition,
        odometer,
        purchaseMethod,
        financePlan: '',
        kmPerYearPlan,
        paymentFrequency,
        term,
        cashDown,
        tradeIn,
        lien,
        financeOptions,
        ...args,
    }
}

const payloadFinanceLease = (state, purchaseMethodSelected, args) => {
    const {
        paymentOptions: { odometer, saleType, taxPlan, transactionToken, vehicleCondition, tradeIn, lien, financeOptions },
    } = state
    const { kmPerYearPlan, paymentFrequency, selectedTerm, selectedCashDown, financePlan } = financeOptions.find(
        ({ purchaseMethod }) => purchaseMethod === purchaseMethodSelected
    )

    return {
        transactionToken,
        saleType,
        taxPlan,
        vehicleCondition,
        odometer,
        purchaseMethod: purchaseMethodSelected,
        financePlan,
        kmPerYearPlan,
        paymentFrequency,
        term: selectedTerm,
        cashDown: selectedCashDown,
        tradeIn,
        lien,
        financeOptions,
        ...args,
    }
}

export const payloadCatalogPaymentOptionTransform = (vehicle, dealerInfos, token) => {
    const { lang, location, orgId, orgUnitId } = dealerInfos

    const {
        vehicleTrim: {
            year,
            make: { slug: make },
            model: { slug: model },
            bodyStyle: { slug: bodyStyle },
        },
    } = vehicle

    return {
        lang,
        location,
        orgId,
        orgUnitId,
        payload: {
            vehicles: [
                {
                    year,
                    make,
                    model,
                    bodyStyle,
                },
            ],
            vehicleCondition: 'new',
        },
        token,
    }
}
